import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deletePropertyGroup } from 'store/actions/propertygroups/deletePropertygroups';
import { fetchPropertygroups } from 'store/actions/propertygroups/fetchPropertygroups';

const PropertygroupsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <ResourceList
                action={ fetchPropertygroups }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table>
                    <TextField
                        column={ {
                            sortable: true,
                            width: '30%',
                        } }
                        label='resources.propertygroups.fields.name'
                        source='name'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '2%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deletePropertyGroup } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

PropertygroupsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(PropertygroupsList);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/list/PropertygroupsList.js